import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Hook to fetch the count of live tags for a team
 * @param {string} teamId - The team ID to fetch tags for
 * @returns {number} - The count of live tags for the team
 */
export function useTeamTagsCount(teamId) {
  const [tagsCount, setTagsCount] = useState(0);

  useEffect(() => {
    if (!teamId) {
      setTagsCount(0);
      return;
    }

    const db = firebase.firestore();
    const unsubscribe = db
      .collection('tags')
      .where('teamId', '==', teamId)
      .where('status', '==', 'live')
      .onSnapshot(
        (snapshot) => {
          setTagsCount(snapshot.size);
        },
        (error) => {
          console.error('Error fetching tags count:', error);
          setTagsCount(0);
        }
      );

    return () => unsubscribe();
  }, [teamId]);

  return tagsCount;
}

